(function (w) {
  var PriceList = function(options = {}) {
    this.selectors = Object.assign({
      container: '.j-price-list',
      generate: '.j-price-list-generate',
      copyLink: '.j-price-list-link'
    }, options.selectors || {});

    this.cls = Object.assign({
      loading: 'is-loading',
    }, options.cls || {});

    this.skin = options.skin || 'default';

    this.container = document.querySelector(this.selectors.container);
    this.ajaxUrl = window.GLOBAL.URI_PREFIX + '_widget/price_list/downloadPriceList';
    this.inProcess = false;

    PriceList.instance = this;
  }

  PriceList.getInstance = function(options) {
    if (this.instance === undefined) {
      return new PriceList(options);
    }

    return this.instance;
  };

  PriceList.prototype = {
    initGenerateButton: function () {
      const self = this;

      self.buttonGenerate = self.container.querySelector(this.selectors.generate);
      self.buttonGenerate.addEventListener('click', function (e) {
        e.preventDefault();
        if (self.inProcess) {
          return;
        }
        self.inProcess = true;
        self.buttonGenerate.classList.add(self.cls.loading);
        self.generateFile(function (response) {
          self.inProcess = false;
          setInnerHTML(self.container, response.html)
          self.buttonGenerate.classList.remove(self.cls.loading);
        });
      });
    },

    initCopyLinkButton: function () {
      const self = this;

      self.buttonCopyLink = self.container.querySelector(this.selectors.copyLink);
      self.buttonCopyLink.addEventListener('click', function (e) {
        e.preventDefault();
        const link = self.buttonCopyLink.getAttribute('href');
        if (link) {
          self.copyTextToClipboard(link);
        }
      });
    },

    generateFile: function (successCallback) {
      const self = this;
      const { skin } = this;

     self.trigger('beforeAjax');
      sendAjax(self.ajaxUrl, { skin }, function (status, response) {
        if (status === 'OK') {
          if (typeof successCallback === 'function') {
            successCallback(response);
            self.trigger('successAjax');
          }
        } else {
          self.trigger('errorAjax', response);
        }

        self.trigger('afterAjax');
      });
    },

    showLoader: function (button) {
      button.classList.add(this.cls.loading);
    },

    hideLoader: function (button) {
      button.classList.remove(this.cls.loading);
    },

    copyTextToClipboard: function (text) {
      this.trigger('beforeCopy');

      if (!navigator.clipboard) {
        const textArea = document.createElement('textarea');
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = '0';
        textArea.style.left = '0';
        textArea.style.position = 'fixed';

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          if (document.execCommand('copy')) {
            this.trigger('afterCopy');
          } else {
            this.trigger('copyError', 'Command not supported');
          }
        } catch (err) {
          this.trigger('copyError', err);
        }

        document.body.removeChild(textArea);

        return;
      }
      const self = this;
      navigator.clipboard.writeText(text).then(function() {
        self.trigger('afterCopy');
      }, function(err) {
        self.trigger('copyError', err);
      });
    },
  }

  Object.assign(PriceList.prototype, TMEvents);

  w.PriceList = PriceList;
})(window);